var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBumpIcon(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M25.585 3H2.414C1.086 3 0 4.099 0 5.442v17.516C0 24.302 1.086 25.4 2.414 25.4h23.171c1.33 0 2.415-1.099 2.415-2.442V5.442C28 4.098 26.914 3 25.585 3zM6.104 22.39c0 .82-.657 1.484-1.466 1.484a1.473 1.473 0 01-1.466-1.484v-5.834c0-.819.656-1.481 1.466-1.481.81 0 1.466.662 1.466 1.481v5.834zm7.19 0c0 .82-.656 1.484-1.465 1.484a1.473 1.473 0 01-1.466-1.484v-5.834c0-.819.656-1.481 1.466-1.481.809 0 1.465.662 1.465 1.481v5.834zm11.64-11.242a1.454 1.454 0 01-2.072 0L21.51 9.784v12.607c0 .82-.658 1.484-1.466 1.484a1.474 1.474 0 01-1.466-1.484V9.781l-1.345 1.378a1.448 1.448 0 01-1.043.441 1.45 1.45 0 01-1.03-.425 1.494 1.494 0 01-.013-2.098l4.87-4.995 4.916 4.967c.574.579.574 1.518.001 2.098v.001z",
    clipRule: "evenodd"
  })));
}

export default SvgBumpIcon;